/// <amd-module name="Agile/Common/Redux/BacklogConfiguration/BacklogConfigurationSagas" />
import { effects, SagaIterator } from "redux-saga";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { BacklogConfigurationActions } from "./BacklogConfigurationActions";
import { IBacklogConfiguration } from "./BacklogConfigurationContracts";

export function* loadBacklogConfiguration(): SagaIterator {
    const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
    const contributionService: IVssContributionService = (yield effects.call([pageContext, pageContext.getService], "IVssContributionService")) as any;
    const backlogConfiguration: IBacklogConfiguration = (yield effects.call(
        [contributionService, contributionService.getData],
        "ms.vss-work-web.agile-backlog-configuration-data-provider"
    )) as any;
    yield effects.put(BacklogConfigurationActions.backlogConfigurationLoaded(backlogConfiguration));
}
